import React, { useState } from 'react'
import styled from 'styled-components'
import { useDispatch } from 'react-redux'
import EngineeringOutlinedIcon from '@mui/icons-material/EngineeringOutlined'
import AssigneeAvatars from './AssigneeAvatars'
import TaskPeopleModal from './TaskPeopleModal'
import { getTasksRoutine, updateTaskRoutine } from 'features/taskManagement/ducks/actions'
import { getTask } from 'services/taskService'

const TaskPeopleAvatars = ({ task, max = 4, emptyLabel = '+ People' }) => {
  const dispatch = useDispatch()
  const [open, setOpen] = useState(false)

  if (!task?.id) return null

  const bpId = task.building?.id || task.buildingPassportId
  const hasPeople = !!(task.assignees?.length || task.approvers?.length || task.externalAssignees?.length)
  const contractor = task.contractor

  const refresh = async () => {
    try {
      const res = await getTask(task.id)
      dispatch(updateTaskRoutine.success(res.data?.data || res.data))
    } catch {
      dispatch(getTasksRoutine({ stable: true }))
    }
  }

  return (
    <>
      <Cluster
        type="button"
        title="Change the people on this task"
        onClick={(e) => { e.stopPropagation(); setOpen(true) }}
      >
        {hasPeople ? (
          <AssigneeAvatars
            assignees={task.assignees}
            approvers={task.approvers}
            externalAssignees={task.externalAssignees}
            max={max}
          />
        ) : (!contractor && <Empty>{emptyLabel}</Empty>)}
        {contractor && (
          <ContractorPill title={`Contractor: ${contractor.name}`}>
            <EngineeringOutlinedIcon style={{ fontSize: 13 }} />
            <span>{contractor.name}</span>
          </ContractorPill>
        )}
      </Cluster>

      {open && (
        <TaskPeopleModal
          task={task}
          bpId={bpId}
          onClose={() => setOpen(false)}
          onSaved={refresh}
        />
      )}
    </>
  )
}

export default TaskPeopleAvatars

const Cluster = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  max-width: 100%;
  padding: 3px 6px;
  border: 1px solid transparent;
  border-radius: 999px;
  background: transparent;
  font: inherit;
  cursor: pointer;
  transition: background 150ms ease, border-color 150ms ease;
  &:hover { background: #eef2f4; border-color: ${({ theme }) => theme.colors.grey?.[400] || '#d1d5db'}; }
`

const Empty = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 2px 4px;
  color: ${({ theme }) => theme.colors.grey?.[700] || '#6b7280'};
  font-size: 12px;
  font-weight: 600;
`

const ContractorPill = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  min-width: 0;
  padding: 2px 8px;
  border-radius: 999px;
  background: #eef2f4;
  color: #475569;
  font-size: 11.5px;
  font-weight: 600;
  svg { color: #64748b; flex-shrink: 0; }
  span { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
`
